<template>
    <div class="listmain "> 
        <h1 class="firTitle">意图</h1>
        <p>意图通常包含用户从发起提问到接收结果的交互过程，是技能的基本组成单位。
       </p>
        <h5 class="codeTitle">意图中文名</h5>
        <p>意图中文名称,2~50个字符,仅支持中文, 保证技能内唯一
       </p>
       
         <h5 class="codeTitle">意图标识名</h5>
        <p>意图调用名称,2~50个字符,仅支持数字,字母,下划线，保证技能内唯一
       </p>


        <h5 class="codeTitle">常用表达</h5>
        <p>常用表达是用户在该意图场景下常用的说法，用户常点击”添加”按钮后,自动识别系统已有
       </p>
        <h5 class="codeTitle">槽位</h5>
        <p>描述意图的数据(键值对的集合),也是实现意图所需要的参数
       </p>
        <h5 class="codeTitle">词典</h5>
        <p>同一领域的术语集合,如，城市词典，歌手词典等。应用于用户表达信息的提取和语义槽的调用
       </p>
        <h5 class="codeTitle">意图确认</h5>
        <p>用户选填项, 其含义为所有槽位填满后,自动向用户发起一次问询以帮助用户进行二次意图确认. 常用在敏感意图(如涉及缴费, 删除等敏感操作)
       </p>
        <p>场景：<br>
        Q:给我手机充值100元话费<br>
AI:请问您要给18612345678充值100元话费么？（发起意图确认）<br>
Q：是的<br>
AI：好的，已帮您充值<br>

       </p>
        <h5 class="codeTitle">系统意图</h5>
        <p>开放平台为用户提供了高频使用的意图，如取消，暂停等，用户可通过添加直接使用
       </p>
       <h5 class="codeTitle">追问语句</h5>
        <p>用户打开必填项开关后，当槽位缺失情况下，会随机选择用户填写的追问语句发
       </p>

        <p>Q:设置今天的闹钟（缺失时间槽位）<br>
           AI:请告诉我时间？ （发起追问）<br>
           Q：早上8点钟（填补槽位）<br>
           AI：好的，已帮您设置好闹钟<br>
       </p>
       
         <h5 class="codeTitle">多轮对话</h5>
        <p>在多数语音交互场景下，用户的需求需要多次语音交互才能完成，为了打造更加自然的语音交互技能，开发者需要使用多轮对话功能。
       </p>

        <p>Q:设置今天的闹钟（缺失时间槽位）<br>
           AI:请告诉我时间？ （发起追问）<br>
           Q：早上8点钟（填补槽位）<br>
           AI：好的，已帮您设置好闹钟<br>
       </p>
        <router-link to='/tutor/zygn_dldh' class="jc">
         查看多轮对话
        </router-link>
        






    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

.jc{
  // margin-top:-10px;
  margin-bottom: 10px;
  display: inline-block;
}

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zygn_yt.vue